import { render, staticRenderFns } from "./Decisionofvacation.vue?vue&type=template&id=dc70a934&scoped=true"
import script from "./Decisionofvacation.vue?vue&type=script&lang=ts"
export * from "./Decisionofvacation.vue?vue&type=script&lang=ts"
import style0 from "./Decisionofvacation.vue?vue&type=style&index=0&id=dc70a934&prod&lang=css"
import style1 from "./Decisionofvacation.vue?vue&type=style&index=1&id=dc70a934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc70a934",
  null
  
)

export default component.exports